// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/86ab2c7a/" + chunkId + "." + __webpack_require__.h() + ".v86ab2c7a.js";
};